document.addEventListener("DOMContentLoaded", function() {
  const popupSection = document.querySelector(
    "#shopify-section-template--20490726670592__17594538404a201581"
  );
  const openBtn = document.querySelector(".hero__button--primary");
  
  if (!popupSection || !openBtn) return;

  // Abrir popup
  openBtn.addEventListener("click", function(e) {
    e.preventDefault();
    popupSection.classList.add("active");
  });

  // Cerrar al hacer click en el pseudo-elemento (x) o en fondo
  popupSection.addEventListener("click", function(e) {
    if (e.target === popupSection) {
      popupSection.classList.remove("active");
    }
  });

  // Detectar click en el pseudo-elemento "::before"
  popupSection.addEventListener("click", function(e) {
    const rect = popupSection.getBoundingClientRect();
    if (e.clientX > rect.right - 60 && e.clientY < rect.top + 60) {
      popupSection.classList.remove("active");
    }
  });




});
